module.exports = __webpack_public_path__ + "img/about-us-img.01e3017d.jpg";